import { formatNumber } from '@platform/design-system';
import type { TFunction } from 'i18next';
import { usePageContext } from './usePageContext.ts';
import styles from './RefineHint.module.css';

export const refineSearchLabel = (
  t: TFunction,
  locale: string,
  shown: number,
  total: number,
): string | undefined =>
  total > shown
    ? t('common.refineSearch', { shown: formatNumber(shown, locale), total: formatNumber(total, locale) })
    : undefined;

export const RefineHint = ({ shown, total }: { shown: number; total: number }) => {
  const { t, locale } = usePageContext();
  const label = refineSearchLabel(t, locale, shown, total);
  return label === undefined ? null : (
    <p role="status" className={styles['hint']}>
      {label}
    </p>
  );
};
